module.exports = __webpack_public_path__ + "img/CRC2_Mono.Macro.c608d7ff.png";